
<mapfre-generic-information-template
[headerImageURL]="'./assets/img/images/headers/legal.png'"
[backButtonUrl]="'/information'"
[type]="'page'">
<h1 class="information-title">{{ 'INFORMATION_LEGAL_1' | translate }}</h1>
<div class="row information-content">
  <div class="col">
    <p class="information-par-margin">
      {{ 'INFORMATION_LEGAL_2' | translate }}
    </p>
    <p class="information-par-margin">
        {{ 'INFORMATION_LEGAL_3' | translate }}
    </p>
    <p class="information-par-margin">
        {{ 'INFORMATION_LEGAL_4' | translate }}
    </p>
    <p class="information-par-margin">
        {{ 'INFORMATION_LEGAL_5' | translate }}
    </p>
    <p class="information-par-margin">
      <strong>{{ 'INFORMATION_LEGAL_6' | translate }}</strong><br>
      {{ 'INFORMATION_LEGAL_7' | translate }}
    </p>
    <p class="information-par-margin">
        <strong>{{ 'INFORMATION_LEGAL_8' | translate }}</strong><br>
        {{ 'INFORMATION_LEGAL_9' | translate }}
    </p>
    <p class="information-par-margin">
        <strong>{{ 'INFORMATION_LEGAL_10' | translate }}</strong><br>
        {{ 'INFORMATION_LEGAL_11' | translate }}
    </p>
    <p class="information-par-margin">
        <strong>{{ 'INFORMATION_LEGAL_12' | translate }}</strong><br>
        {{ 'INFORMATION_LEGAL_13' | translate }}
    </p>
    <p class="information-par-margin">
      
      CONTINUE …
    </p>
  </div>
</div>
</mapfre-generic-information-template>